import { render, staticRenderFns } from "./ChatListHeader.vue?vue&type=template&id=2bfe6320&scoped=true"
import script from "./ChatListHeader.vue?vue&type=script&lang=js"
export * from "./ChatListHeader.vue?vue&type=script&lang=js"
import style0 from "./ChatListHeader.vue?vue&type=style&index=0&id=2bfe6320&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bfe6320",
  null
  
)

export default component.exports